<template>
  <div>
    <fieldset class="border p-3">
      <legend>
        <small style="font-size:15px; font-weight: bold">new dead stock</small>
      </legend>
      <div>
        <form @submit.prevent="newDeadStock()">
          <div class="row">
            <div class="col-md-6">
              <input type="hidden" class="product_id" :value="Product.id" />
              <div class="form-group">
                <label>Product name</label>
                <input
                  type="text"
                  class="form-control product_name input_rounded"
                  :value="Product.product_name"
                  placeholder="product name"
                  readonly
                />
              </div>
              <div class="form-group">
                <label>Product measurement</label>
                <select
                  name="product_measurement"
                  class="form-control input_rounded product_measurement"
                  :value="Product.product_measurement"
                  readonly
                >
                  <option value>Select Measurement</option>
                  <option value="KG">KILOGRAMS</option>
                  <option value="PCS">PIECES</option>
                  <option value="LTS">LITRES</option>
                  <option value="SET">SET</option>
                  <option value="PAIR">PAIR</option>
                  <option value="MTR">METRES</option>
                </select>
              </div>
              <div class="form-group">
                <label>Selling price</label>
                <input
                  type="number"
                  class="form-control selling_price input_rounded"
                  :value="Product.selling_price"
                  placeholder="selling price"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Product description</label>
                <textarea
                  class="form-control product_description input_rounded"
                  :value="Product.product_description"
                  placeholder="product description"
                  readonly
                ></textarea>
              </div>
              <div class="form-group">
                <label>Buying price</label>
                <input
                  type="number"
                  class="form-control buying_price input_rounded"
                  :value="Product.buying_price"
                  placeholder="buying price"
                  readonly
                />
              </div>
              <div class="form-group">
                <label>Stock</label>
                <input
                  type="text"
                  class="form-control added_stock"
                  placeholder="add stock"
                  required
                />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat btn-rounded creatingStock">
            <i class="fa fa-plus"></i> add stock
          </button>
          <button type="button" class="btn btn-info btn-flat btn-rounded creatingStockLoader">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import router from "../router/index";
export default {
  created() {
    if (this.$store.getters.Product.length === 0) {
      router.push("/stock");
    }
  },
  computed: {
    ...mapGetters(["Product"])
  },
  methods: {
    ...mapActions(["newDeadStock"])
  }
};
</script>
<style scoped>
.creatingStockLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/deadstocks/deadstock.vue